// Manager list — sourced from /managers.xlsx provided by TMC
export const MANAGERS = [
    "Aimee Reed Andrews",
    "Allison Wyble",
    "Amy Kittle",
    "Anna Katherine Poole",
    "Hope Carr",
    "Ashley Thompson",
    "Bijlee Parsotan",
    "Brian Daugharthy",
    "Brooke Loftin",
    "Chance Victoriano",
    "Chelsea Abrahamsen",
    "Chris Bruenderman",
    "Christen Coulter",
    "Christina Bruenderman",
    "Crislyn Johnson",
    "Daniel Garrett",
    "Denise Ward",
    "Derek Pritchard",
    "Dreama Waldrop",
    "Dustin Schwab",
    "Emily Akins",
    "Erin Roberts",
    "Erika Stutts",
    "George Koons",
    "Jaime Held",
    "Jamie Brown",
    "Jayme Renfrow",
    "Jesse Lang",
    "Joel Wright",
    "Joseph Arthur",
    "Judie Krupp",
    "Julie Vlasich",
    "Karen Fox",
    "Kevin Cezat",
    "Kevin King",
    "Kristie Back",
    "Leah Victoriano",
    "Leslie Scott",
    "Leslie Welch",
    "Mark Keene",
    "Mark Waldrop",
    "Maria Lawrence",
    "Mariann Maguschak",
    "Mary Tyler",
    "Matthew Baum",
    "Mike Harris",
    "Miranda Malley",
    "Regina McKenzie",
    "Renette Mahaffey",
    "Rebecca Armoney",
    "Ricky Bassett",
    "Robin Lindley",
    "Samantha Cunningham",
    "Sean Meehan",
    "Shane Malecha",
    "Skyler Gaillard",
    "Timothy Plunkett",
    "Trina Fisk",
    "Ty Burgess",
    "Yvette Bernhardt",
];
